export const DataExtractorConstantsTracks = {
    HELPDESK_REPORTS_DATAEXTRACTOR_EXIT: 'helpdesk-reports-dataextractor-exit',
};
